import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tech-clients',
  templateUrl: './tech-clients.component.html',
  styleUrls: ['./tech-clients.component.css']
})
export class TechClientsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
